'use client';

import Image from 'next/image';
import { useRef, Fragment } from 'react';
import { easeIn, easeInOut, easeOut, motion, useScroll, useTransform } from 'framer-motion';
import { PortableTextBlock } from 'sanity';
import { PortableText } from 'next-sanity';
import { richTextComponent } from '@/sanity/sanityPortableText';
import { useIsMobile } from '@/hooks/useIsMobile';
import ChipText from '@/components/global/ChipText';
import {GROQImage} from "@/sanity/lib/types";
import {GROQButton} from "@/sanity/lib/definitions";
import qualitySectionBg from '@/public/home/qualitySectionBg.png';
import { CTAButton } from '@/shadcn/ui/button';
import { cn } from '@/lib/utils';

interface ILastSectionProps {
  title: PortableTextBlock[];
  button: GROQButton;
  backgroundImage?: GROQImage;
  backgroundImageMobile?: GROQImage;
  className: string;
}

export default function LastSection({
  title,
  button,
  backgroundImage,
  backgroundImageMobile,
  className,
}: ILastSectionProps) {
  const isMobile = useIsMobile();

  return (
    <section className="flex flex-col w-full relative min-h-[95rem] lg:min-h-[137.75rem]">
      <div className="container flex flex-col items-center gap-[4rem] pt-[7.76rem] lg:pt-[18.5rem] w-full relative z-10">
        <div className={cn("flex flex-col gap-[1.75rem] lg:gap-[2rem] richtext richtext-center prose-headings:text-[5rem] lg:prose-headings:text-[7.5rem] prose-p:text-[2rem] lg:prose-p:text-[2.5rem] prose-p:text-[#072922]/50", className)}>
          <PortableText value={title} components={richTextComponent} />
        </div>
        <CTAButton data={button} className="w-full lg:w-auto"/>
      </div>

      {backgroundImage && backgroundImageMobile && (
        <Image
          src={isMobile ? backgroundImageMobile.src : backgroundImage.src}
          alt="Image Background"
          width={isMobile ? backgroundImageMobile.width : backgroundImage.width}
          height={isMobile ? backgroundImageMobile.height : backgroundImage.height}
          className="absolute bottom-0 left-0 lg:inset-0 !w-full !h-auto lg:!h-full lg:object-cover lg:object-center z-0"
          quality={100}
        />
      )}
    </section>
  );
}
